


















import Vue from "vue";

export default Vue.extend({
  props: {
    percentage: Number
  },
  data: () => ({})
});
